
import { Component, OnInit, ViewChild } from '@angular/core';
import {  MessageService, SelectItem } from 'primeng/api';
import { TranslateService } from '@ngx-translate/core';

import { GlobalService } from 'src/app/_services/global.service';

import { Router } from '@angular/router';
import { GridService } from 'src/app/_services/grid.service';

import { ApiService } from 'src/app/_services/api.service';
import { CheckboxRenderer } from  'src/app/components/grid-addons/checkbox-renderer/checkbox-renderer.component';
import { BarChart } from "echarts/charts";




import {
  ColDef,
  CellEditingStartedEvent,
  IAggFunc,
  IAggFuncParams,
  GridReadyEvent,
  ITooltipParams,
} from 'ag-grid-community';
import 'ag-grid-community/dist/styles/ag-grid.css';
import 'ag-grid-community/dist/styles/ag-theme-alpine.css';
import 'ag-grid-enterprise';
import * as moment from 'moment';
import { Dropdown } from 'primeng/dropdown';
import { environment } from 'src/environments/environment';



@Component({
  selector: 'app-survey-results-pptx',
  templateUrl: './survey-results-pptx.component.html',
  styleUrls: ['./survey-results-pptx.component.css'],
  providers: [ MessageService]
})
export class SurveyResultsPptxComponent implements OnInit {
  onlymandatory:boolean=false;
  pptxrsa:any=null;
  lavillacompanylist:any[] = [];  
  lavillaarealist:any[] = [];  
  pptxlavillacompany:any=null;
  pptxsurveyList:any[] = [];  
  pptxlavillaarea:any=null;
  pptxsurvey:any=null;
  companylist: SelectItem[] = [];  
  rsalist: SelectItem[] = [];  
  echartsOptions: object = {};
  echartsOptionsCompany: object = {};
  echartsOptionsArea: object = {};

  columnsInit: ColDef[] = [];
  columns: ColDef[] = [];
  frameworkComponents = {
    checkboxRenderer: CheckboxRenderer
  }
  surveylist: any[] = [];  
  surveycompanylist: any[] = [];  
  schema: SelectItem[] = [];  
  public rowGroupPanelShow: 'always' | 'onlyWhenGrouping' | 'never' = 'always';
  surveysresults: any[] = [];
  gridApi;
  gridColumnApi;
  groupIncludeFooter=true;
  groupIncludeTotalFooter=true;
  suppressAggFuncInHeader=true;
  schemaName='';
  surveyName='';
  
  
  company:any=null;

  filtro={
    survey:null,
    schema:null,
    ischart:false,
    details:true,
   
  };


  legend:any=[];
  itemslist:any=[];
  series:any=[];
  chartsList:any[]=[];
  legendD:any=[];
  legend_S:any=[];
  itemslist_S:any=[];
  series_S:any=[];
  legend_A:any=[];
  noArea=false;
  itemslist_A:any=[];
  series_A:any=[];

  constructor(
    private router: Router,
    private messageService: MessageService,
    private translate: TranslateService,
    public globalService: GlobalService,
    private apiService: ApiService,
  ) {


  }

  

  ngOnInit(): void {
   
    const params: any = {PageSize : 10000};
    this.companylist.push({
      label:'All',
      value:0
    });
    this.surveylist.push({
      label:'Select survey',value:'',company:''
    });
    this.apiService.get('surveys/listall',params).subscribe(data => {
      data.Result.forEach((q)=>{
        if(q.company){
          if(this.companylist.filter((x)=>x.value==q.company).length==0){
            this.companylist.push({
              label:q.company.replace('_',' '),
              value:q.company
            });
          }
        }
        this.surveylist.push({
          label:q.name,value:q.id,company:q.company
        });
        this.surveycompanylist=this.surveylist;
      });
      
    });
    this.apiService.get('surveys-startup-models/listall',params).subscribe(data => {
      data.Result.forEach((q)=>{
        this.schema.push({
          label:q.name,value:q.id
        });
      });
    });
  
   // this.load();
   
  }


  pptx_satisfaction(){
    let params={
      pptxsurveyList:this.pptxsurveyList,
      onlymandatory:this.onlymandatory
    };
  
    this.apiService.get('surveys/surveys_pptx_satisfaction',params).subscribe(data => {
      window.open(
        environment.QUESTIONARI_URL+data.Result['filepptx'],
        '_blank' // <- This is what makes it open in a new window.
      );
    });
 
  }

  pptx_poi(){
     let params:any={
        survey:this.pptxsurvey
      };
 
  
    this.apiService.get('surveys/surveys_pptx_poi',params).subscribe(data => {
      window.open(
        environment.QUESTIONARI_URL+data.Result['filepptx'],
        '_blank' // <- This is what makes it open in a new window.
      );
    });
  }

  pptx_per_domanda(what){
    let params:any={
        survey:this.pptxsurvey
      };
 
    if(what=='rsa'){
      params={
      survey:this.pptxsurvey,
      rsa:this.pptxrsa
    };
   }  
    if(what=='company'){
      params={
      survey:this.pptxsurvey,
      company:this.pptxlavillacompany
      };
    }
    if(what=='area'){
      params={
      survey:this.pptxsurvey,
      area:this.pptxlavillaarea
      };
    }
    params.onlymandatory=this.onlymandatory;
  
    this.apiService.get('surveys/surveys_pptx_per_domanda',params).subscribe(data => {
      window.open(
        environment.QUESTIONARI_URL+data.Result['filepptx'],
        '_blank' // <- This is what makes it open in a new window.
      );
    });

  }
   
  percFormatter(params) {
   if(params.value)
    return params.value.toString()+' %';
  else 
   return '';
  }



changeSurvey(event, dd: Dropdown){
 this.surveyName=dd.selectedOption.label;
}

changeCompany(event, dd: Dropdown){
 
  if(this.company==0){

    this.surveycompanylist=this.surveylist;
  } else {
  
    this.surveycompanylist=this.surveylist.filter((c)=>c.company==this.company);
    this.surveycompanylist.unshift({
      label:'Select survey',value:'',company:''
    });
  }

  this.rsalist=[];
}

changeSurvey2(event, dd: Dropdown){
 if(dd.selectedOption.value!='')
  this.apiService.get('dosurvey/get',{id:dd.selectedOption.value,fromArkiweb:true}).subscribe(data => {
    for (const g of data.Result) {
  
      this.apiService.get('dosurvey/rsalistall',{rsa_id:g['rsa_list_id'],fromArkiweb:true}).subscribe(data => {
        for (const g of data.Result) { 
          this.rsalist=[];
          g['rsalist'].forEach((r:any)=>{
            this.rsalist.push({
              value:r['code'],
              label:r['description']
            });
          });
         
        }
      });
      this.apiService.get('dosurvey/areacompanylistall',{rsa_id:g['rsa_list_id']}).subscribe(data => {
        this.lavillaarealist=[];
     
        data.Result.aree.forEach((a)=>{
          this.lavillaarealist.push({
            value:a,
            label:a
          });
        });
        this.lavillacompanylist=[];
        data.Result.societa.forEach((a)=>{
          this.lavillacompanylist.push({
            value:a,
            label:a
          });
        });
  
      });
    }
  });
 }


changeSchema(event, dd: Dropdown){
  this.schemaName=dd.selectedOption.label;
 }
 
}